// extracted by mini-css-extract-plugin
module.exports = {"card-content":"card-image-type-8-m__card-content__tS-Ne","tags":"card-image-type-8-m__tags__1D7UH"};